import { useEffect, useState } from 'react';
// import StepBox from '../components/StepBox';
// import RotatingCoin from '../components/RotatingCoin';
// import SwapKroEth from '../assets/swap-kro-eth.webp';
// import SwapEthZc from '../assets/swap-eth-zkcandy.webp';
// import Button from '../components/Button';
import Banner from '../components/Banner';
import { useAppKit, useAppKitAccount, useAppKitEvents } from '@reown/appkit/react';
import { useNavigate } from "react-router";
import iconX from '../assets/icon-header-x.webp';
import iconDiscord from '../assets/icon-header-discord.webp';
import iconTelegram from '../assets/icon-header-telegram.webp';


const Home = () => {
  const { isConnected, address } = useAppKitAccount();
  const { open } = useAppKit();
  const navigate = useNavigate();
  const events = useAppKitEvents();
  const [connectIntent, setConnectIntent] = useState(false);

  const handleConnectAndNavigate = async () => {
    if (isConnected) {
      navigate('/deposit-info');
      return;
    }
    setConnectIntent(true); // mark that user clicked the button
    open({ view: 'Connect' });

  };

  useEffect(() => {
    if (
      connectIntent &&
      events?.data?.event === 'CONNECT_SUCCESS' && address
    ) {
      navigate('/deposit-info');
    }
  }, [events, connectIntent, navigate]);


  return (
    <div className="home pb-5">
      <div className="container mx-auto px-4 xl:px-4">
        <Banner />

        <div className="flex flex-col justify-center max-w-[800px] mx-auto">
          <div className="box content p-5 md:p-10">
            <div className="left-dot"></div>
            <div className="right-dot"></div>

            <div className="text-lg md:text-2xl xl:text-4xl uppercase">
              <div className="mb-2">
                The $KRO Swap Event has
              </div>
              <div className="text-[#FD00CA]">
                officially concluded
              </div>
            </div>

            <div className="text-sm md:text-base border-4 rounded-xl p-4 border-black bg-white text-style-reset mt-8 max-w-[500px] mx-auto">
              <div className="text-black italic">
                Deposits of $KRO are <span className="text-[#FD00CA] uppercase">no longer accepted</span>. <br />
                Be sure to follow our social media channels <br />
                for the most recent updates.
              </div>

              <div className="flex justify-center mt-4 space-x-4">
                <a href="https://discord.com/invite/zkcandy" target="_blank" rel="noopener noreferrer">
                  <img className="bg-[#FD00CA] border-4 border-black" src={iconDiscord} alt="X" />
                </a>
                <a href="https://x.com/ZKcandyHQ" target="_blank" rel="noopener noreferrer">
                  <img className="bg-[#FD00CA] border-4 border-black" src={iconX} alt="X" />
                </a>
                <a href="https://t.me/zkcandy" target="_blank" rel="noopener noreferrer">
                  <img className="bg-[#FD00CA] border-4 border-black" src={iconTelegram} alt="X" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;